import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ pill }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: "var(--card__background)",
    color: "var(--text_color)",
    fontSize: "14px",
    borderRadius: pill === "false" ? "12px" : "999px",
    padding: "8px 10px",
    boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
    zIndex: 9999,
  },
  // [`& .MuiTooltip-arrow`]: {
  //   color: "#6860ee",
  // },
}));

const CustomTooltip = ({
  children,
  title,
  // arrow = true,
  placement = "bottom",
  pill = true,
}) => {
  return (
    <StyledTooltip
      title={title}
      // arrow={arrow}
      placement={placement}
      enterDelay={200}
      pill={pill.toString()}
      PopperProps={{
        sx: {
          zIndex: 9999
        }
      }}
    >
      <span>{children}</span>
    </StyledTooltip>
  );
};

export default CustomTooltip;
